import { ReactNode } from "react";
import styles from "./Header.module.css";

interface HeaderProps {
  children: ReactNode;
}

export default function Header({ children }: HeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.left_col}>
        <div className={styles.logo}>
          <a href="https://www.studierendenwerk-siegen.de">

            <img
              src="https://www.studierendenwerk-siegen.de/wp-content/themes/thema_vyn/img/Logo.png"
              alt="Studierendenwerk Siegen"
            />
          </a>
        </div>
      </div>
      {children}
    </header>
  );
}
